import React, { useEffect, useState } from 'react';
import { CustomButton, CustomImage, CustomModal, useText, Text } from '@src/components';
import modalClose from '@src/assets/icons/icon-close.svg';
import './payWithEFTHavale.scss';
import { Header } from '@src/components/CustomDialog';
import modalWarning from '@src/assets/icons/icon-modal-warning.svg';
import dayjs from '@src/utils/day';
import { defaultDateFormat } from '@src/utils/keys';

const PayWithEFTHavale = ({ paymentAction, modalAction, orderDate }) => {
  const [isPayDayToday, setIsPayDayToday] = useState(false);

  useEffect(() => {
    const today = dayjs().hour(23).minute(59).millisecond(0).second(59);
    const activationDate = dayjs(orderDate).hour(23).minute(59).millisecond(0).second(59);
    setIsPayDayToday(activationDate.unix() === today.unix());
  }, [orderDate]);

  return (
    <CustomModal
      className="pay-with-eft-havale-modal"
      maskClosable={false}
      footer={false}
      title={<Header title={useText('warning2')} type={'warning'} icon={modalWarning}></Header>}
      visible={true}
      onCancel={() => modalAction(false)}
      closeIcon={<CustomImage src={modalClose} />}
    >
      <div className={'modal-inner-container'}>
        <div className={'text-1'}>
          <Text t="yourBalanceActivationDate" />{' '}
          {isPayDayToday ? 'bugün' : dayjs(orderDate).format(defaultDateFormat)}{' '}
          <Text t="appearsAs" /> <br />
          <Text t="cardBalances2" />{' '}
          {isPayDayToday
            ? 'bugün içinde'
            : dayjs(orderDate).format(defaultDateFormat) + ' tarihinde'}{' '}
          <Text t="forPaymentToBeActivated" />{' '}
          {isPayDayToday
            ? 'bugün içinde'
            : dayjs(orderDate).format(defaultDateFormat) + ' tarihinde'}{' '}
          <Text t="mustBeCompleted" />
        </div>
        <div></div>
        <CustomButton
          id="ticketRestaurant-paymentModals-payWithEFTHavale-payWithEFTHavale-pay-later"
          className="pay-later"
          onClick={paymentAction}
        >
          <Text t="okBtn2" />
        </CustomButton>
      </div>
    </CustomModal>
  );
};

export default PayWithEFTHavale;
